import React from "react";
import { CircledNumber } from "../CircledNumber/CircledNumber";
export interface NumberedListProps {
  list: {
    title: string;
    description?: string;
    children?: React.ReactNode;
    circledColor?: string;
  }[];
}

export const NumberedList = ({ ...props }: NumberedListProps) => {
  return (
    <>
      {props.list.map((item, index) => (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "25px 1fr",
            alignItems: "baseline",
            gap: "10px",
            width: "100%",
          }}
        >
          <CircledNumber number={index + 1} color={item.circledColor} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p
              style={{
                color: "#1F47D3",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "20px",
                marginBottom: "3px",
              }}
            >
              {item.title}
              {item.description && (
                <>
                  <br />
                  <span
                    style={{
                      color: "#6A6868",
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  >
                    {item.description}
                  </span>
                </>
              )}
            </p>
            {item.children}
          </div>
        </div>
      ))}
    </>
  );
};
